/**
 * @name fetchImgData - Function for extracting text from a base64.txt file get from strapi
 * @param {url} url - strapi image url of image with .base64 extension
 * @return {string} data - it will retun the data url string which can be passed to blurdataurl prop directly or via a state
 */

const fetchImgData = async url => {
  try {
    const response = await fetch(url);
    const data = await response.text();
    return { data, error: null };
  } catch (error) {
    console.error('error', error);
    return { data: null, error: true };
  }
};

export default fetchImgData;
